import { authServiceApi } from "../../../../app/authServiceApi";
import { API_URL } from "../../../../constants/apiUrl";
import { CommonResponse, GetQueryArgsType } from "../../../../types";
import {
  AllLeaveAllocationParams,
  AllLeaveAllocationResponse,
  AllLeaveRequestParams,
  AllLeaveRequestResponse,
  LeaveAllocationByJobResponse,
  LeaveRequestByJobResponse,
  LeaveRequestDetailsParams,
  LeaveRequestDetailsResponse,
} from "./leaveManagement.type";

export const salarySlabApi = authServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    // ------ Mutations ------
    createLeaveAllocation: builder.mutation({
      query: (data) => ({
        url: API_URL.createLeaveAllocation,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetLeaveAllocation"];
        return [];
      },
    }),
    updateLeaveAllocation: builder.mutation({
      query: ({ data, id }) => ({
        url: `${API_URL.updateLeaveAllocation}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, _error, arg) => {
        if (result)
          return [
            "GetLeaveAllocation",
            { type: "GetLeaveAllocation", id: arg.id },
          ];
        return [];
      },
    }),
    deleteLeaveAllocation: builder.mutation({
      query: ({ id }) => ({
        url: `${API_URL.deleteLeaveAllocation}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, _error, arg) => {
        if (result)
          return [
            "GetLeaveAllocation",
            { type: "GetLeaveAllocation", id: arg.id },
          ];
        return [];
      },
    }),

    createLeaveRequest: builder.mutation({
      query: (data) => ({
        url: API_URL.createLeaveRequest,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetLeaveRequest"];
        return [];
      },
    }),

    approveOrRejectLeaveRequest: builder.mutation({
      query: ({ data, id }) => ({
        url: `${API_URL.approveOrRejectLeaveRequest}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, _error, arg) => {
        if (result) {
          return ["GetLeaveRequest", { type: "GetLeaveRequest", id: arg.id }];
        }
        return [];
      },
    }),

    // ------ Queries ------
    getAllLeaveAllocation: builder.query<
      CommonResponse<AllLeaveAllocationResponse>,
      GetQueryArgsType<AllLeaveAllocationParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllLeaveAllocation,
        ...queryArgs,
      }),
      providesTags: ["GetLeaveAllocation"],
    }),

    getLeaveAllocationByJob: builder.query<
      CommonResponse<LeaveAllocationByJobResponse>,
      number
    >({
      query: (id) => ({
        url: `${API_URL.getLeaveAllocationByJob}/${id}`,
      }),
      providesTags: (_result, _error, id) => [
        { type: "GetLeaveAllocation", id },
      ],
    }),

    getAllLeaveRequest: builder.query<
      CommonResponse<AllLeaveRequestResponse>,
      GetQueryArgsType<AllLeaveRequestParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllLeaveRequest,
        ...queryArgs,
      }),
      providesTags: ["GetLeaveRequest"],
    }),

    getLeaveRequestDetails: builder.query<
      CommonResponse<LeaveRequestDetailsResponse>,
      { id: number; args?: GetQueryArgsType<LeaveRequestDetailsParams> }
    >({
      query: ({ id, args }) => ({
        url: `${API_URL.getLeaveRequestDetails}/${id}`,
        ...args,
      }),
      providesTags: (_result, _error, args) => [
        { type: "GetLeaveRequest", id: args.id },
      ],
    }),

    getLeaveRequestByJob: builder.query<
      CommonResponse<LeaveRequestByJobResponse>,
      number
    >({
      query: (id) => ({
        url: `${API_URL.getLeaveAllocationByJob}/${id}/user`,
      }),
      providesTags: (_result, _error, id) => [{ type: "GetLeaveRequest", id }],
    }),
  }),
});

export const {
  // ------ Mutation Hooks ------
  useCreateLeaveAllocationMutation,
  useUpdateLeaveAllocationMutation,
  useDeleteLeaveAllocationMutation,
  useCreateLeaveRequestMutation,
  useApproveOrRejectLeaveRequestMutation,

  // ------ Query Hooks ------
  useGetAllLeaveAllocationQuery,
  useGetLeaveAllocationByJobQuery,
  useGetAllLeaveRequestQuery,
  useGetLeaveRequestDetailsQuery,
  useGetLeaveRequestByJobQuery,
} = salarySlabApi;
